<template>
  <div class="expand" :class="{ 'expanded': component.expanded }">
    <button @click="toggle">
      <span class="icon-rotate">
        <FontAwesomeIcon icon="fa-solid fa-chevron-down"/>
      </span>
      <span v-html="title"></span>
      <span></span>
    </button>
    <Expansion :expanded="component.expanded">
      <div>
        <slot></slot>
      </div>
    </Expansion>
  </div>
</template>

<script lang="ts" setup>
import {
  reactive,
} from 'vue';
import Expansion from '@/components/Expansion.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';

library.add(faChevronDown);

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  expanded: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  type: {
    type: String,
    required: false,
    default: () => 'default',
  },
});

const component = reactive({
  expanded: props.expanded,
});

const toggle = () => {
  component.expanded = !component.expanded;
};
</script>

<style lang="scss">
@import 'src/scss/component-helpers';

.expand {
  > button {
    width: 100%;
    text-align: left;
    outline: 0 !important;
    border: 0 !important;
    background: transparent !important;
    padding: 0;
    color: #293033;
    display: grid;
    gap: 5px;
    align-items: center;
    grid-template-columns: auto auto 1fr;
    font-size: .75rem;

    @media(min-width: map-get($grid-breakpoints, 'lg')) {
      font-size: .875rem;
    }

    i, svg {
      font-size: .875rem;
    }

    > span:last-child {
      height: 1px;
      background-color: #E7F1F5;
    }

    .icon-rotate {
      > i, > svg {
        will-change: transform;
        transform: rotate(0deg);
        transition: transform .575s ease-out;
        transform-origin: center;
      }
    }
  }

  &.expanded {
    > button {
      .icon-rotate {
        > i, > svg {
          transform: rotate(-180deg);
        }
      }
    }
  }
}
</style>
